import React, { useState, useRef, useEffect } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import { storage } from '../../../firebase/firebaseConfig';
import { ref, uploadBytes } from 'firebase/storage';
import AvatarEditor from 'react-avatar-editor';
import defaultPic from '../../Images/BitBlue-Person-Default-Profile-Picture.png';
import { settingsFunctions } from '../../../functions/settings';
import './EnterprisePicEditor.css';

function ProfilePicEditor(props) {
    const { setView, setVcardObj, profile_pic, route, uid } = props;
    const { updateVcardObject } = settingsFunctions;
    const editor = useRef();
    
    const [ position, setPosition ] = useState({x: 0.5, y: 0.5});
    const [ scale, setScale ] = useState(1);
    const [ file, setFile ] = useState(null);
    const [ fileName, setFileName ] = useState('');

    useEffect(() => {
        if (profile_pic) {
            setFile(`${profile_pic}?${Date.now()}`);
        } else {
            setFile(defaultPic);
        };
    },[profile_pic])

    const handleReset = () => {
        const input = document.getElementById('profile-pic-img');
        input.value = '';
        setFile(`${profile_pic}?${Date.now()}`);
        setFileName('');
    }

    const handlePhotoToEdit = (e) => {
        setFile(e.target.files[0]);
        setFileName(e.target.files[0].name);
    };

    const handleScale = (e) => {
        const scale = parseFloat(e.target.value);
        setScale(scale);
    };

    const handlePositionChange = (position) => {
        setPosition(position);
    };

    const handlePorfilePicSave = async () => {
        if (editor.current) {
            await editor.current.getImageScaledToCanvas().toBlob(async blob => {
                const newFile = new File([blob], 'profile_image', {lastModified: Date.now(), type: blob.type});
                const fileName = `${newFile.name}.${newFile.type.slice(newFile.type.indexOf('/') + 1)}`;
                const storageRef = ref(storage, `${uid}/${fileName}`);

                try {
                    await uploadBytes(storageRef, newFile)
                    const vcardEdit = {};
                    vcardEdit.profile_pic = `https://storage.googleapis.com/${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}/${uid}/${fileName}`;
                    
                    if (setVcardObj) {
                        setVcardObj(prev => ({...prev, profile_pic: vcardEdit.profile_pic}));
                    };
                    
                    await updateVcardObject(vcardEdit, uid).then(() => setView('form'));
                } catch (err) {
                    console.log('Error setting profile pic', err);
                };
            });
        }
    };

    const handleRemoveProfilePic = async () => {
        if (setVcardObj) {
            setVcardObj(prev => ({...prev, profile_pic: ''}));
        };

        const vcardEdit = {};
        vcardEdit.profile_pic = '';
        await updateVcardObject(vcardEdit, uid);
        setView('form');
    };

    useEffect(() => {
        const editor = document.querySelector('.profile-pic-editor');
        const input = document.getElementById('profile-pic-img-input');

        const handleCanvasClick = (e) => {
            if (e.target === editor) {
                input.click();
            };
        };
        
        let moved;
        const downListener = () => {
            moved = false;
        };
        window.addEventListener('mousedown', downListener);

        let moveListener = () => {
            moved = true;
        };
        window.addEventListener('mousemove', moveListener);

        let upListener = (e) => {
            if (!moved) {
                handleCanvasClick(e);
            };
        };
        window.addEventListener('mouseup', upListener);

        return () => {
            window.removeEventListener('mousedown', downListener);
            window.removeEventListener('mousemove', moveListener);
            window.removeEventListener('mouseup', upListener);
        };
    },[]);

    return (
        <>
            <div className='profile-pic-top-container'>
                <div className='profile-pic-editor-back-btn' onClick={e => {e.preventDefault(); setView('form')}}>
                    <i className='fas fa-arrow-left'></i>
                    Back
                </div>
                <div className='profile-pic-editor-reset-btn' onClick={handleReset}>
                    Reset
                </div>
            </div>
            <AvatarEditor 
                className='profile-pic-editor'
                crossOrigin='anonymous'
                ref={editor}
                borderRadius={100}
                border={25}
                image={file}
                scale={scale}
                width={200}
                height={200}
                position={position}
                onPositionChange={handlePositionChange}
                color={[0,0,0,0.4]}
            />
            <div className='ent-profile-pic-image-input-container'>
                <label htmlFor='ent-profile-pic-img-input' className='ent-profile-pic-upload'>Upload Profile Image</label>
                <input
                    type='file'
                    id='ent-profile-pic-img-input'
                    onChange={handlePhotoToEdit}
                    accept='image/*'
                />
                <label htmlFor='ent-profile-pic-img-input'>{fileName ? fileName : 'No File Selected'}</label>
            </div>
            <div className='profile-pic-editor-range-wrap'>
                <label htmlFor='custom-range'>Zoom</label>
                <input  
                    type='range' 
                    id='profile-pic-img-range'
                    min='0.5'
                    max='3'
                    step='0.25'
                    value={scale}
                    onChange={handleScale}
                />
            </div>
            <InputGroup className='justify-content-center'>
                <button className='profile-pic-editor-apply-btn' onClick={handlePorfilePicSave} disabled={!file}>Apply Changes</button>
                <button className='profile-pic-editor-remove-btn' style={{backgroundColor: '#888'}} onClick={handleRemoveProfilePic} disabled={!file}>Remove</button>
            </InputGroup>
        </>
    );
};

export default ProfilePicEditor;